import Swal from "sweetalert2";
import i18n from "plugins/i18n";

const Message = {
  success(text: string, timer?: number) {
    void Swal.fire({
      title: i18n.t("mensaje.correcto"),
      text,
      icon: "success",
      showConfirmButton: false,
      timer: timer || 3000,
    });
  },
  error(text: string, timer?: number) {
    void Swal.fire({
      title: i18n.t("mensaje.error"),
      text,
      icon: "error",
      showConfirmButton: false,
      timer: timer || 3000,
    });
  },
  warning(text: string, timer?: number) {
    void Swal.fire({
      title: i18n.t("mensaje.advertencia"),
      text,
      icon: "warning",
      showConfirmButton: false,
      timer: timer || 3000,
    });
  },
  alert() {},
  async confirm(text: string, quitarDangerMode?: boolean) {
    const result = await Swal.fire({
      title: i18n.t('mensaje.confirmar'),
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: i18n.t('form.aceptar'),
      cancelButtonText: i18n.t('form.cancelar'),
      confirmButtonColor: quitarDangerMode ? undefined : '#d33',
    });

    return result.isConfirmed;
  },
};

export default Message;
